import { observable } from 'mobx';
import { noop } from '@src/utils/common-util';
import { useEffect } from 'react';
import useMount from '@src/utils/hooks/use-mount';

class ChronicleModalStore {
  @observable expandVideoUrl = '';
  @observable closeCallback = noop;

  // 标题正文数据 + 关联人物/关联势力数据
  @observable data = null;
  // 词条数据
  @observable dictData = null;
  // 关联人物
  @observable characterDataMap = null;
  // 关联势力
  @observable factionDataMap = null;

  // 列表角标
  @observable activeIndex = null;
  // 列表长度
  @observable listLength = null;
  // 切换回调
  @observable switchCallback = noop;

  constructor(options = {}) {
    Object.assign(this, options);
  }

  /**
   * 点击切换上一页
   */
  onClickPrev = () => {
    this.switchCallback('prev');
  };

  /**
   * 点击切换下一页
   */
  onClickNext = () => {
    this.switchCallback('next');
  };

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    // this.clearStyle();
  };

  use() {
    useMount(() => {
      return () => {
        this.characterDataMap = null;
        this.factionDataMap = null;
      };
    });
    useEffect(() => { }, []);
  }
}

export default ChronicleModalStore;
